import maxLodash from 'lodash.max';

/**
 * This is a port of max function from lodash.
 * Lodash is bloated and not necessary in many cases.
 */
export const max = maxLodash;
